import { 
  OPINION_ON_PRICING,
  WHAT_ASPECTS_HARD_TO_USE,
  WHAT_MISSING_FEATURE,
  WHAT_TECHNICAL_ISSUES,
  WHAT_BUILDER_SWITCHING_TO,
  WHY_NOT_NEEDED
} from './subSurvey';

export const REASONS_LEAVING = {
  question: 'uninstall.survey.main.question',
  answers: [
    {
      id: 1,
      label: "uninstall.survey.main.answer.1",
      subSurvey: OPINION_ON_PRICING
    },
    {
      id: 2,
      label: "uninstall.survey.main.answer.2",
      subSurvey: WHAT_ASPECTS_HARD_TO_USE
    },
    {
      id: 3,
      label: "uninstall.survey.main.answer.3",
      subSurvey: WHAT_MISSING_FEATURE
    },
    {
      id: 4,
      label: "uninstall.survey.main.answer.4",
      subSurvey: WHAT_TECHNICAL_ISSUES
    },
    {
      id: 5,
      label: "uninstall.survey.main.answer.5",
      subSurvey: WHAT_BUILDER_SWITCHING_TO
    },
    {
      id: 6,
      label: "uninstall.survey.main.answer.6",
      subSurvey: WHY_NOT_NEEDED
    },
    {
      id: 7,
      label: "uninstall.survey.main.answer.7",
      showFurtherSurvey: true,
      isRequired: true
    },
  ],
  furtherSurveyQuestion: 'uninstall.survey.main.further.question'
}

